import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import type { UserProfile } from 'types/api'

export const regionsQueryKey = ['profile']

export function useProfile(enabled: boolean) {
  async function getProfile() {
    const response = await apiClient.get<UserProfile>(SNA_PREFIX + 'users/me')

    return response.data
  }

  return useQuery({
    queryFn: getProfile,
    queryKey: regionsQueryKey,
    enabled
  })
}
